import { useEffect } from 'react';
import GoogleTagManager from 'react-gtm-module';

export const useGTMInitialize = () => {
  useEffect(() => {
    if (import.meta.env.MODE === 'production') {
      GoogleTagManager.initialize({ gtmId: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID });
    }
  }, []);
};
